var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: 1000, title: "预览发票" },
          model: {
            value: _vm.preViewModal.show,
            callback: function ($$v) {
              _vm.$set(_vm.preViewModal, "show", $$v)
            },
            expression: "preViewModal.show",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { color: "rgb(241, 115, 72)", "font-size": "14px" },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "330px" } }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "24px",
                        width: "330px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("增值税虚拟发票")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { width: "330px", "text-align": "right" } },
                    [
                      _c("span", [_vm._v("开票日期:")]),
                      _c(
                        "span",
                        {
                          staticStyle: { color: "black", "margin-left": "4px" },
                        },
                        [_vm._v(_vm._s(_vm.getCurrentDate()))]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "border-top": "0.5px solid",
                    "border-left": "0.5px solid",
                    "border-color": "black",
                    "margin-top": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder",
                          staticStyle: { width: "30px", height: "90px" },
                        },
                        [_vm._v("购买方")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "invoiceBorder",
                          staticStyle: {
                            width: "470px",
                            height: "90px",
                            display: "flex",
                            "justify-content": "center",
                            "flex-direction": "column",
                            "padding-left": "4px",
                          },
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v("名    称:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.preViewModal.invoiceModel
                                      .invoiceBuyerName
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("纳税人识别号:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.preViewModal.invoiceModel
                                      .invoiceBuyerTaxNum
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("地址 、电话:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.preViewModal.invoiceModel
                                      .invoiceBuyerAddress
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerTel
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("开户行及账号:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.preViewModal.invoiceModel
                                      .invoiceBuyerBank
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.preViewModal.invoiceModel
                                        .invoiceBuyerAccount
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder",
                          staticStyle: { width: "30px", height: "90px" },
                        },
                        [_vm._v("密码区")]
                      ),
                      _c("div", {
                        staticClass: "invoiceBorder",
                        staticStyle: { width: "470px", height: "90px" },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "line-height": "2",
                    "border-left": "0.5px solid",
                    "border-color": "black",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "300px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("项目名称")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("规格型号")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("单位")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("数量")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("单价")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("金额")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("税率")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("税额")]
                  ),
                ]
              ),
              _vm._l(_vm.preViewModal.productList, function (item) {
                return _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "line-height": "2",
                      "border-left": "0.5px solid",
                      "border-color": "black",
                      color: "black",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "300px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(item.productName))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(item.productSpec))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(item.unit))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(item.quantity))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(_vm.numberToFixed(item.price, 4)))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(_vm.numberToFixed(item.value, 4)))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(item.taxRate * 100) + "%")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "invoiceBorder",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "text-align": "center",
                        },
                      },
                      [_vm._v(_vm._s(_vm.numberToFixed(item.taxValue, 4)))]
                    ),
                  ]
                )
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "line-height": "2",
                    "border-left": "0.5px solid",
                    "border-color": "black",
                    color: "black",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "300px",
                        height: "30px",
                        "text-align": "center",
                        color: "rgb(241, 115, 72)",
                      },
                    },
                    [_vm._v("合计")]
                  ),
                  _c("div", {
                    staticClass: "invoiceBorder",
                    staticStyle: {
                      width: "100px",
                      height: "30px",
                      "text-align": "center",
                    },
                  }),
                  _c("div", {
                    staticClass: "invoiceBorder",
                    staticStyle: {
                      width: "100px",
                      height: "30px",
                      "text-align": "center",
                    },
                  }),
                  _c("div", {
                    staticClass: "invoiceBorder",
                    staticStyle: {
                      width: "100px",
                      height: "30px",
                      "text-align": "center",
                    },
                  }),
                  _c("div", {
                    staticClass: "invoiceBorder",
                    staticStyle: {
                      width: "100px",
                      height: "30px",
                      "text-align": "center",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.numberToFixed(_vm.preViewModal.totalValue, 4)
                        )
                      ),
                    ]
                  ),
                  _c("div", {
                    staticClass: "invoiceBorder",
                    staticStyle: {
                      width: "100px",
                      height: "30px",
                      "text-align": "center",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "100px",
                        height: "30px",
                        "text-align": "center",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.numberToFixed(_vm.preViewModal.totalTax, 4))
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "line-height": "2",
                    "border-left": "0.5px solid",
                    "border-color": "black",
                    color: "black",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "300px",
                        height: "30px",
                        "text-align": "center",
                        color: "rgb(241, 115, 72)",
                      },
                    },
                    [_vm._v("价税合计(大写)")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "invoiceBorder",
                      staticStyle: {
                        width: "700px",
                        height: "30px",
                        "text-align": "center",
                        display: "flex",
                        "justify-content": "space-between",
                        padding: "0 30px",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.smalltoBIG(
                              _vm.preViewModal.invoiceModel.invoiceValue
                            )
                          )
                        ),
                      ]),
                      _c("div", [
                        _c(
                          "span",
                          { staticStyle: { color: "rgb(241, 115, 72)" } },
                          [_vm._v("（小写）")]
                        ),
                        _c("span", [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.numberToFixed(
                                  _vm.preViewModal.invoiceModel.invoiceValue,
                                  2
                                )
                              )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "border-left": "0.5px solid",
                    "border-color": "black",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder",
                          staticStyle: { width: "30px", height: "90px" },
                        },
                        [_vm._v("销售方")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "invoiceBorder",
                          staticStyle: {
                            width: "470px",
                            height: "90px",
                            display: "flex",
                            "justify-content": "center",
                            "flex-direction": "column",
                            "padding-left": "4px",
                          },
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v("名    称:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v("广州缤纷园艺有限公司")]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("纳税人识别号:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.preViewModal.salerTaxNum))]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("地址 、电话:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.preViewModal.salerAddress))]
                            ),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("开户行及账号:")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.preViewModal.bankInfo) + " ")]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "vertical-text invoiceBorder",
                          staticStyle: { width: "30px", height: "90px" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c("div", {
                        staticClass: "invoiceBorder",
                        staticStyle: { width: "470px", height: "90px" },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "4px",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "250px" } }, [
                    _c("span", [_vm._v("收款人:")]),
                    _c(
                      "span",
                      { staticStyle: { color: "black", "margin-left": "4px" } },
                      [_vm._v(_vm._s(_vm.preViewModal.payee))]
                    ),
                  ]),
                  _c("div", { staticStyle: { width: "250px" } }, [
                    _c("span", [_vm._v("复核:")]),
                    _c(
                      "span",
                      { staticStyle: { color: "black", "margin-left": "4px" } },
                      [_vm._v(_vm._s(_vm.preViewModal.checker))]
                    ),
                  ]),
                  _c("div", { staticStyle: { width: "250px" } }, [
                    _c("span", [_vm._v("开票人:")]),
                    _c(
                      "span",
                      { staticStyle: { color: "black", "margin-left": "4px" } },
                      [_vm._v(_vm._s(_vm.preViewModal.clerk))]
                    ),
                  ]),
                  _c("div", { staticStyle: { width: "250px" } }, [
                    _c("span", [_vm._v("销售方:")]),
                    _c("span", [_vm._v("（章）")]),
                  ]),
                ]
              ),
            ],
            2
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }